// Filename - components/landing/StudentWinners.js

import React  from "react";
import { Container, Row, Col} from "react-bootstrap";
import { Link } from "react-router-dom";


export default function StudentWinners (){


    return (
      <Container fluid className="p-5">
         <Row className="mx-3 mt-3 mb-3">
            <h3 className="display-4">Our Student Winners </h3>
            <p className="lead">A shout out to our amazing students and their ideas, some of whom have won national and state level awards through our program. Check out some of their profiles on our <Link to="http://blog.mindantix.com/category/inventor-spotlight/" target="_blank"> inventor spotlight </Link> series. </p>
            
         </Row>
         <Row className="mt-4" style={{opacity:'0.6'}}>
            <Col className="col-6 col-md-2 mb-4">
               <img 
                  src="images/winners/GeethNunna-small.jpeg" 
                  className="rounded"
                  width="100%"
                  alt="Geeth N." 
                  fluid="true" />
            </Col>
            <Col className="col-6 col-md-2 mb-4">
               <img 
                  src="images/winners/PahalSah-small.png" 
                  className="rounded"
                  width="100%"
                  alt="Pahal S." 
                  fluid="true" />
            </Col>
            <Col className="col-6 col-md-2 mb-4">
               <img 
                  src="images/winners/MananGhosh-small.jpg" 
                  className="rounded"
                  width="100%"
                  alt="Manan G." 
                  fluid="true" />
            </Col>
            <Col className="col-6 col-md-2 mb-4">
               <img 
                  src="images/winners/NivedhaNaren-small.jpg" 
                  className="rounded"
                  width="100%"
                  alt="Nivedha N." 
                  fluid="true" />
            </Col>
            <Col className="col-6 col-md-2 mb-4">
               <img 
                  src="images/winners/AyanaBharadwaj-small.jpg" 
                  className="rounded"
                  width="100%"
                  alt="Ayana B." 
                  fluid="true" />
            </Col>
            <Col className="col-6 col-md-2 mb-4">
               <img 
                  src="images/winners/TaraRedmond-small.jpg" 
                  className="rounded"
                  width="100%"
                  alt="Tara R." 
                  fluid="true" />
            </Col>
            <Col className="col-6 col-md-2 mb-4">
               <img 
                  src="images/winners/NoraRedmond-small.jpg" 
                  className="rounded"
                  width="100%"
                  alt="Nora R." 
                  fluid="true" />
            </Col>
            <Col className="col-6 col-md-2 mb-4">
               <img 
                  src="images/winners/SachitaGhosh-small.jpg" 
                  className="rounded"
                  width="100%"
                  alt="Sachita G." 
                  fluid="true" />
            </Col>
            <Col className="col-6 col-md-2 mb-4">
               <img 
                  src="images/winners/AaronLiu-small.jpeg" 
                  className="rounded"
                  width="100%"
                  alt="Aaron L." 
                  ffluid="true" />
            </Col>
            <Col className="col-6 col-md-2 mb-4">
               <img 
                  src="images/winners/KrithiIyer-small.JPG" 
                  className="rounded"
                  width="100%"
                  alt="Krithi I." 
                  fluid="true" />
            </Col>
            <Col className="col-6 col-md-2 mb-4">
               <img 
                  src="images/winners/MaxBaryshnikov-small.JPG" 
                  className="rounded"
                  width="100%"
                  alt="Max B." 
                  ffluid="true" />
            </Col>
            <Col className="col-6 col-md-2 mb-4">
               <img 
                  src="images/winners/SuhaniNog-small.png" 
                  className="rounded"
                  width="100%"
                  alt="Suhani N." 
                  fluid="true" />
            </Col>
            <Col className="col-6 col-md-2 mb-4">
               <img 
                  src="images/winners/NehaKrishnakumar-small.png" 
                  className="rounded"
                  width="100%"
                  alt="Neha K." 
                  fluid="true" />
            </Col>
            <Col className="col-6 col-md-2 mb-4">
               <img 
                  src="images/winners/NikitaKuzishchin-small.png" 
                  className="rounded"
                  width="100%"
                  alt="Nikita K." 
                  fluid="true" />
            </Col>
            <Col className="col-6 col-md-2 mb-4">
               <img 
                  src="images/winners/AbhishekVaidya-small.png" 
                  className="rounded"
                  width="100%"
                  alt="Abhishek V." 
                  fluid="true" />
            </Col>
            <Col className="col-6 col-md-2 mb-4">
               <img 
                  src="images/winners/AngadArora-small.png" 
                  className="rounded"
                  width="100%"
                  alt="Angad A." 
                  fluid="true" />
            </Col>
            <Col className="col-6 col-md-2 mb-4">
               <img 
                  src="images/winners/SterlingHunter-small.JPG" 
                  className="rounded"
                  width="100%"
                  alt="Sterling H." 
                  fluid="true" />
            </Col>
            <Col className="col-6 col-md-2 mb-4">
               <img 
                  src="images/winners/SimratThind-small.png" 
                  className="rounded"
                  width="100%"
                  alt="Simrat T." 
                  fluid="true" />
            </Col>

         </Row>

      </Container>
    )

}
